import {FC, ReactNode} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {hasValue} from '@kcast-fe/core';

export interface IHorizontalTab {
  id: string | number;
  label: ReactNode;
  count?: number;
}

interface IProps {
  tabs: IHorizontalTab[];
  selectedId?: string | number;
  onSelect: (id: string | number) => void;
}

const HorizontalTabsFC: FC<IProps> = ({tabs, selectedId, onSelect}) => {
  return (
    <Flex
      p={'1px'}
      w={'100%'}
      direction={'row'}
      overflowX={'auto'}
      borderRadius={'24px'}
      border={'thin solid'}
      borderColor={'{colors.borderDefault}'}
      css={{scrollbarWidth: 'none', '&::-webkit-scrollbar': {display: 'none'}}}
    >
      {tabs.map((tab) => {
        const isActive = tab.id === selectedId;

        return (
          <Flex
            key={tab.id}
            gap={'6px'}
            flexShrink={0}
            alignItems={'center'}
            borderRadius={'24px'}
            p={hasValue(tab.count) ? '6px 8px 6px 14px' : '6px 14px'}
            cursor={'pointer'}
            bg={isActive ? '{colors.bgMain}' : 'transparent'}
            color={isActive ? '{colors.textPrimary}' : '{colors.textSecondary}'}
            border={'thin solid'}
            borderColor={'transparent'}
            transition={'background var(--tr-100-ei), color var(--tr-100-ei)'}
            _hover={{color: '{colors.textPrimary}'}}
            onClick={() => onSelect(tab.id)}
          >
            <Box fontWeight={'500'} fontSize={'14px'}>
              {tab.label}
            </Box>
            {tab.count !== undefined && (
              <Box
                fontSize={'12px'}
                fontWeight={'500'}
                borderRadius={'10px'}
                p={'0 8px'}
                flexShrink={0}
                bg={'{colors.bgSurface}'}
                color={'{colors.textTertiary}'}
              >
                {tab.count}
              </Box>
            )}
          </Flex>
        );
      })}
    </Flex>
  );
};

export const HorizontalTabs = HorizontalTabsFC;
